import styled from "styled-components";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import { Bio } from "../../data/constants";

const FooterContainer = styled.div`
  width: 100%;
  padding: 2rem 0;
  display: flex;
  justify-content: center;
  background: ${({ theme }) => theme.card};
`;

const FooterWrapper = styled.footer`
  width: 100%;
  max-width: 1200px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  padding: 1rem;
  color: ${({ theme }) => theme.text_primary};
`;

const Logo = styled.h1`
  font-weight: 600;
  font-size: 20px;
  color: ${({ theme }) => theme.primary};
  letter-spacing: 1px;
`;

const Nav = styled.nav`
  display: flex;
  gap: 1.5rem;
  flex-wrap: wrap;
  justify-content: center;
`;

const NavLink = styled.a`
  color: ${({ theme }) => theme.text_primary};
  text-decoration: none;
  font-size: 1rem;
  transition: all 0.2s ease;

  &:hover {
    color: ${({ theme }) => theme.primary};
    transform: translateY(-2px);
  }
`;

const SocialMediaIcons = styled.div`
  display: flex;
  gap: 1.2rem;
  margin-top: 0.5rem;
`;

const SocialMediaIcon = styled.a`
  font-size: 1.5rem;
  color: ${({ theme }) => theme.text_primary};
  position: relative;
  transition: all 0.2s ease;

  &:hover {
    color: ${({ theme }) => theme.primary};
    transform: scale(1.2);
  }

  &::after {
    content: attr(data-tooltip);
    position: absolute;
    bottom: 130%;
    left: 50%;
    transform: translateX(-50%);
    background: ${({ theme }) => theme.text_primary};
    color: ${({ theme }) => theme.bg};
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 0.75rem;
    opacity: 0;
    visibility: hidden;
    transition: 0.3s;
  }

  &:hover::after {
    opacity: 1;
    visibility: visible;
  }
`;

const Copyright = styled.p`
  margin-top: 1rem;
  font-size: 0.85rem;
  color: ${({ theme }) => theme.soft2};
  text-align: center;
`;

function Footer() {
  return (
    <FooterContainer>
      <FooterWrapper>
        <Logo>Ravi Singh</Logo>

        <Nav>
          <NavLink href="#about">About</NavLink>
          <NavLink href="#services">Services</NavLink>
          <NavLink href="#skills">Skills</NavLink>
          <NavLink href="#experience">Experience</NavLink>
          <NavLink href="#projects">Projects</NavLink>
          <NavLink href="#education">Education</NavLink>
          <NavLink href="#contact">Contact</NavLink>
        </Nav>

        <SocialMediaIcons>
          <SocialMediaIcon href={Bio.facebook} target="_blank" rel="noopener noreferrer" data-tooltip="Facebook">
            <FacebookIcon />
          </SocialMediaIcon>

          <SocialMediaIcon href={Bio.twitter} target="_blank" rel="noopener noreferrer" data-tooltip="Twitter">
            <TwitterIcon />
          </SocialMediaIcon>

          <SocialMediaIcon href={Bio.linkedin} target="_blank" rel="noopener noreferrer" data-tooltip="LinkedIn">
            <LinkedInIcon />
          </SocialMediaIcon>

          <SocialMediaIcon href={Bio.insta} target="_blank" rel="noopener noreferrer" data-tooltip="Instagram">
            <InstagramIcon />
          </SocialMediaIcon>
        </SocialMediaIcons>

        <Copyright>
          © {new Date().getFullYear()} Ravi Singh. All rights reserved.
        </Copyright>
      </FooterWrapper>
    </FooterContainer>
  );
}

export default Footer;